module.exports = __webpack_public_path__ + "img/message-heart-square.4a5ee053.svg";